// extracted by mini-css-extract-plugin
module.exports = {"logo":"_404-module--logo--24KmO","titre":"_404-module--titre--23Y2C","contenu":"_404-module--contenu--cRt77","bouton":"_404-module--bouton--2EOds"};